import { useEffect } from "react";
import { useErrorStore } from "@shared/store/errorStore";
import { toast } from "sonner";
import { logger } from "@/shared/utils/logger";

export const ErrorHandler = () => {
  const { errorMessage, setErrorMessage } = useErrorStore();

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      logger.error("Showing toast:", errorMessage);
      setErrorMessage(null);
    }
  }, [errorMessage, setErrorMessage]);

  return null;
};
